"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areContentPathsEqual = exports.getRandomContentPath = exports.unHashContentPath = exports.hashContentPath = void 0;
const lodash_1 = __importDefault(require("lodash"));
const CONTENT_PATH_DELIMITER = '|';
const hashContentPath = (contentPath) => {
    return contentPath.join(CONTENT_PATH_DELIMITER);
};
exports.hashContentPath = hashContentPath;
const unHashContentPath = (hashedContentPath) => {
    return hashedContentPath.split(CONTENT_PATH_DELIMITER);
};
exports.unHashContentPath = unHashContentPath;
const getRandomContentPath = (numTopics = 5, numSubtopics = 10, numChapters = 10) => {
    const topic = lodash_1.default.random(numTopics - 1);
    const subtopic = topic * 10 + lodash_1.default.random(numSubtopics - 1);
    const chapter = subtopic * 10 + lodash_1.default.random(numChapters - 1);
    return [`Topic${topic}`, `Subtopic${subtopic}`, `Chapter${chapter}`];
};
exports.getRandomContentPath = getRandomContentPath;
const areContentPathsEqual = (contentPathA, contentPathB) => {
    return (0, exports.hashContentPath)(contentPathA) === (0, exports.hashContentPath)(contentPathB);
};
exports.areContentPathsEqual = areContentPathsEqual;
//# sourceMappingURL=index.js.map